// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.batch-detail-container {
  padding: 0;
  margin: 0;
}

/* Card Styling */
.card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.card-header {
  background-color: #e9ecef;
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.card-header h5 {
  color: #0b2d71;
  font-size: 1.1rem;
  font-weight: bold;
}

.card-body {
  padding: 1.5rem;
  background-color: #ffffff;
}

/* Tests List */
.tests-list {
  margin-left: 1rem;
}

.form-check {
  padding-left: 0;
  margin-bottom: 0.75rem;
}

.form-check-input {
  cursor: pointer;
  width: 1.1rem;
  height: 1.1rem;
  margin-top: 0.15rem;
}

.form-check-label {
  margin-left: 1.5rem;
  cursor: pointer;
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/batches/batch-detail/batch-detail.component.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".batch-detail-container {\n  padding: 0;\n  margin: 0;\n}\n\n/* Card Styling */\n.card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n.card-header {\n  background-color: #e9ecef;\n  padding: 1rem;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.card-header h5 {\n  color: #0b2d71;\n  font-size: 1.1rem;\n  font-weight: bold;\n}\n\n.card-body {\n  padding: 1.5rem;\n  background-color: #ffffff;\n}\n\n/* Tests List */\n.tests-list {\n  margin-left: 1rem;\n}\n\n.form-check {\n  padding-left: 0;\n  margin-bottom: 0.75rem;\n}\n\n.form-check-input {\n  cursor: pointer;\n  width: 1.1rem;\n  height: 1.1rem;\n  margin-top: 0.15rem;\n}\n\n.form-check-label {\n  margin-left: 1.5rem;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
